import "../DatePicker.css";
import { jsxs, jsx } from "react/jsx-runtime";
import { DatePicker as DatePicker$1 } from "antd";
import Label from "./internal/Label.js";
import { useTheme } from "./Theme/UI.js";
import "./Theme/themeUtils.js";
import "./Theme/themes.js";
const base = "DatePicker_base_f58fc";
const css = {
  base
};
const DatePicker = ({ label, ...props }) => {
  const {
    themeSettings: { className: themeClass }
  } = useTheme();
  const composedProps = {
    ...props,
    popupClassName: themeClass,
    style: { minWidth: props.width },
    width: void 0
  };
  const classes = [css.base, themeClass];
  return /* @__PURE__ */ jsxs("div", { className: classes.join(" "), children: [
    label && /* @__PURE__ */ jsx(Label, { children: label }),
    /* @__PURE__ */ jsx(DatePicker$1, { ...composedProps })
  ] });
};
export {
  DatePicker as default
};
